<template>
  <MRow class="flex-1" :gutter="0">
    <MCol :size="12" class="flex flex-col">
      <FlotoCrudContainer
        ref="realtedKbRef"
        :fetch-fn="fetchRelatedKb"
        :scrollable="false"
        as-table
        :columns="columns"
        hide-table-headers
        message-size="small"
      >
        <template v-slot:name="{ item }">
          <td>
            <ResourceListTitle
              :name="item.name"
              :subject="item.subject"
              :created-at="item.updatedAt"
              open-in-new-tab
              external-link
              :link="
                $modules.getModuleRoute(
                  isPortalLogin ? 'support-portal' : $constants.KNOWLEDGE,
                  'read',
                  {
                    params: { id: item.id },
                  }
                )
              "
            />
          </td>
        </template>
      </FlotoCrudContainer>
    </MCol>
  </MRow>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import ResourceListTitle from '@components/resource/resource-list-title'
import { relatedKnowledgeForCreateTicketApi } from '../knowledge-api'

export default {
  name: 'RelatedKnowledge',
  components: { ResourceListTitle },
  props: {
    relatedKnowledgeSearchText: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    this.columns = [
      {
        name: '',
        key: 'name',
        resizable: false,
      },
    ]
    this.moduleName = this.$constants.REQUEST
    return {
      loading: true,
    }
  },
  computed: {
    ...authComputed,
  },
  watch: {
    relatedKnowledgeSearchText(newValue, preValue) {
      if (newValue !== preValue) {
        this.refresh()
      }
    },
  },
  methods: {
    fetchRelatedKb() {
      if (this.relatedKnowledgeSearchText) {
        return relatedKnowledgeForCreateTicketApi(
          this.isPortalLogin,
          this.moduleName,
          this.relatedKnowledgeSearchText
        ).then((data) => {
          this.loading = false
          return data
        })
      }
    },
    refresh() {
      this.$refs.realtedKbRef.refresh()
    },
  },
}
</script>
